import React, { Component } from 'react';

import HttpRunner from '../query';
import examples from '../../../utils/examples';
import urlHandler from '../../../utils/urlHandler';

class DocV1AdminRestart extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    render() {
        return (
            <div className="bucket" id="top">
                <span id="sysinfo_endpoint">
                    <span className='heading-1'>Admin Restart</span>
                </span>
                <code className="api-definition">
                    <span className="get-badge">GET</span>&nbsp;{urlHandler.API_ENDPOINT_V1_ADMIN_RESTART}?{'{'}query parameters{'}'}
                </code>
                <div className="description">
                    This endpoint allows an adminstrator to reload the custom dictionaries or custom Regular Expression (RegEx) 
                    patterns. This allows a custom dictionary (whitelist or blacklist) or custom RegEx patterns to be modified 
                    and reloaded without restarting the entire ees-service.
                </div>

                <div className="deprecated">
                    <span className="fa fa-exclamation-triangle">&nbsp;</span>
                    This request is only available to on-prem customers of Finch For Text.
                </div>

                <h4 className="heading-2">Request</h4>
                <div className="heading-3">Query Parameters</div>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">service</td>
                        <td className="meaning">The service to restart</td>
                        <td className="type">String</td>
                        <td className="type">Required.<br/>
                            <br/>
                            Valid values:<br/>
                            <b>regex</b> - Reload regex patterns.<br/>
                            <b>dictionary</b> - Reload custom dictionaries.<br/>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-2">Response</h4>
                <div className="description">
                    The response object contains the result of the restart operation.
                </div>

                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">code</td>
                        <td className="meaning">The HTTP status code from the request.
                        </td>
                        <td className="type">Integer</td>
                        <td className="type"></td>
                    </tr>
                    <tr>
                        <td className="attribute">message</td>
                        <td className="meaning">A response message from the restart operation.
                        </td>
                        <td className="type">String</td>
                        <td className="type"></td>
                    </tr>
                    </tbody>
                </table>

                <div className="heading-2">Example</div>
                <div className="example-content host">
                    <pre>
                        GET {urlHandler.API_ENDPOINT_V1_ADMIN_RESTART}?service=regex<br/>
                        Authorization: Bearer [YOUR-API-KEY]<br/>
                    </pre>
                </div>

                <HttpRunner query="adminRestart" 
                    response={!this.state.dynamicSampleSearch ? JSON.stringify(examples.EXAMPLE_RESPONSE_V1_ADMIN_RESTART) : null}
                />
            </div>
        );
    }
}

export default DocV1AdminRestart;